<template lang="pug">
  .section.is-fullheight.is-flex.is-flex-direction-column.is-justify-content-center.is-align-items-center
    div.has-text-centered
      span.icon.is-large.has-text-danger.is-large
        i.mdi.mdi-alert-circle-outline.mdi-48px
      h3.title.is-3(v-t="'account.disabled.title'")
      p.subtitle.is-6(v-t="'account.disabled.subtitle'")
      .buttons.is-centered.mb-5
        a.mr-3(href="mailto:support@emly.com")
          span.icon
            i.mdi.mdi-email-outline
          span(v-t="'actions.contact_support'")
        a(href="tel:+37411288088" v-if="company.country === 'AM'")
          span.icon
            i.mdi.mdi-phone-outline
          span 011 288 088
      .has-text-centered
        router-link.is-size-4-mobile(to='/signout')
          
          span {{$t('actions.signout')}}

</template>

<script>
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters('company', ['trialHasEnded']),
    company() {
      return this.$store.state.company.company
    }
  }
}
</script>
